import { config } from "../../utils/constants";
import axios from "axios";

export const getPatientCertificates = () => {

  const requestConfig = {
    url: `${config.escortLeaveServices}certificates`

  };

  return axios.request(requestConfig);
};

export const getPatientCertificatesUrl = (id) => {
  const requestConfig = {
    url: `${config.escortLeaveServices}certificates/url/${id}`
  };

  return axios.request(requestConfig);
};

export const saveOrUpdateProviderDetails = (payload, isEdit) => {
  // coerce isEdit to "true"/"false" string for your backend route
  const editFlag = String(Boolean(isEdit));
  const requestConfig = {
    method: "POST",
    url: `${config.escortLeaveServices}providerDetails/${editFlag}`,
    data: payload,
    headers: {
      "Content-Type": "application/json"
    }
  };
  return axios.request(requestConfig);
};

export const getProviderDetailsById = (id) => {
  const requestConfig = {
    url: `${config.escortLeaveServices}providerDetails/${id}`
  };

  return axios.request(requestConfig);
};

export const getProviderDetails = () => {
  const requestConfig = {
    url: `${config.escortLeaveServices}allProviderDetails`
  };

  return axios.request(requestConfig);
};

export const deleteProviderDetail = (id) => {
  const requestConfig = {
    method: "DELETE",
    url: `${config.escortLeaveServices}deleteProvider/${id}`

  };

  return axios.request(requestConfig);
};